import { Button, Col, Row, Stack } from "react-bootstrap"
import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import CStack from "../../components/CStack"
import { useEffect, useState } from "react"
import Label from "../../components/Label"
import Input from "../../components/Input"
import Loading from "../../components/Loading"
import { useIPStore } from "../../api/ip/store"
import IPWhitelistItem from "../../containers/Admin/IPWhitelistItem"

const defaultErr = { ip: "", description: "" }
const ADD_IP = "addIP"

const AddIPView = ({ onAdded = () => { } }) => {
    const [adding, setAdding] = useState(false)
    const [ipData, setIpData] = useState({ ip: "", description: "" })
    const [err, setErr] = useState(defaultErr)
    const { refreshDialog, hideDialog } = useUXStore(state => state)
    const { addToWhitelist } = useIPStore(state => state)

    const validateIP = (ip: string) => {
        const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/
        const ipv6Regex = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/
        return ipv4Regex.test(ip) || ipv6Regex.test(ip)
    }

    const onAdd = () => {
        setAdding(true)
        refreshDialog({
            id: ADD_IP,
            onClose: undefined,
        }, false)
        setErr(defaultErr)

        if (!validateIP(ipData.ip)) {
            setErr({ ip: "Invalid IP address format", description: "" })
            refreshDialog({
                id: ADD_IP,
            }, true)
            setAdding(false)
            return
        }

        addToWhitelist(ipData.ip, ipData.description).then(code => {
            switch (code) {
                case "200":
                    hideDialog(ADD_IP)
                    onAdded()
                    break;
                case "already_whitelisted":
                    setErr({ ip: "IP already whitelisted", description: "" })
                    break;
                case "incomplete_param":
                    setErr({ ip: "Required", description: "" })
                    break
                default:
                    console.error(code)
                    break;
            }
            if (code !== "200") {
                refreshDialog({
                    id: ADD_IP,
                }, true)
            }
        })
            .catch(err => {
                console.error(err)
            }).finally(() => {
                setAdding(false)
            })
    }

    return <>
        <Stack gap={2}>
            <Row>
                <Col><Label>IP Address</Label></Col>
                <Col><Input
                    disabled={adding}
                    label={err.ip}
                    error
                    onChange={(e: any) => setIpData({ ...ipData, ip: e.target.value })}
                /></Col>
            </Row>
            <Row>
                <Col><Label>Description (Optional)</Label></Col>
                <Col><Input
                    disabled={adding}
                    label={err.description}
                    error
                    onChange={(e: any) => setIpData({ ...ipData, description: e.target.value })}
                /></Col>
            </Row>
            <Row>
                <Col><Button style={{ float: "right" }} onClick={onAdd} disabled={adding}>Add</Button></Col>
            </Row>
        </Stack>
    </>
}

const IPWhitelist = () => {
    const { refreshDialog, addToast } = useUXStore(state => state)
    const { whitelistLoading, whitelist, retrieveWhitelist, removeFromWhitelist } = useIPStore(state => state)

    useEffect(() => {
        retrieveWhitelist()
    }, [])

    const onAdd = () => {
        refreshDialog({
            id: ADD_IP,
            title: "Add IP to Whitelist",
            visible: true,
            content: <AddIPView onAdded={onAdded} />,
            onConfirm: undefined,
        }, true)
    }

    const onDelete = (ip: string) => {
        refreshDialog({
            id: "deleteIP",
            title: "Remove IP from Whitelist",
            visible: true,
            content: <div>Are you sure you want to remove <b>{ip}</b> from the whitelist?<br />This action may affect security settings.</div>,
            onConfirm() {
                removeFromWhitelist(ip)
                    .then(code => {
                        switch (code) {
                            case "200":
                                addToast("", "IP removed from whitelist successfully!")
                                break;
                            default:
                                addToast("Failed", "Failed to remove IP from whitelist!")
                                break;
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        }, true)
    }

    const onAdded = () => {
        retrieveWhitelist()
    }

    if (whitelistLoading) return <Loading center />

    return <>
        <ButtonControl text="Add IP to Whitelist" buttonLabel="Add" onClicked={onAdd} />
        <div className="mt-3 mb-2" style={{ fontSize: '13px', color: '#666' }}>
            <span className="text-primary">*</span> This is different from company whitelisting. IP addresses added here will bypass auto-detection of  activities (e.g., services/servers accessing CPASS).
        </div>
        <CStack header={`Whitelisted IPs${whitelist && whitelist.length > 0 ? ` (${whitelist.length})` : ''}`}>
            {
                whitelist !== null && whitelist.length === 0 &&
                <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                    No whitelisted IPs
                </div>
            }
            {
                whitelist !== null && whitelist!.map((item, i) =>
                    <IPWhitelistItem
                        key={"ip" + item.ip}
                        entry={item}
                        onDelete={onDelete}
                    />)
            }
        </CStack>
    </>
}

export default IPWhitelist